export default function AboutHero() {
  return (
    <section className="relative min-h-[75vh] flex items-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/b087f70588fdd2dbdeb965710227e840.jpg"
          alt="Surfer running into the ocean at sunrise"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-[#0B2C26]/65 via-[#0B2C26]/50 to-[#0B2C26]/85" />
      </div>
      <div className="relative z-10 max-w-7xl mx-auto px-6 pt-24 pb-20 w-full text-center">
        <div className="inline-flex items-center gap-2 bg-[#FF6B35]/20 border border-[#FF6B35]/40 rounded-full px-4 py-1.5 mb-6 backdrop-blur-sm">
          <i className="ri-sun-fill text-[#FF6B35] text-sm" />
          <span className="text-[#FF6B35] text-xs font-bold uppercase tracking-widest">Founded 2008 · California, USA</span>
        </div>
        <h1 className="text-5xl md:text-7xl font-black text-white mb-6 leading-tight">
          Built for Surfers<br />
          <span className="text-[#FF6B35]">Who Don&apos;t</span><br />
          Want to Wait
        </h1>
        <p className="text-white/75 text-xl max-w-xl mx-auto leading-relaxed mb-10">
          PHIX Doctor was created by surfers who refused to let a ding decide whether they surf today.
        </p>
        <div className="flex flex-wrap gap-3 justify-center">
          {['Pioneered Sun-Powered Resin', 'Eco-Conscious Innovation', '60+ Countries', '1,200+ Retailers'].map((item) => (
            <div key={item} className="flex items-center gap-2 bg-white/10 border border-white/20 rounded-full px-4 py-2">
              <i className="ri-check-line text-[#FF6B35] text-xs" />
              <span className="text-white/80 text-sm font-medium">{item}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
